export default "__VITE_ASSET__DaZPfETS__"